export default "__VITE_ASSET__gOpBNSELCNdnM_yZlyA5OQ__ 480w, __VITE_ASSET__ZoP2ebLT5e$hm8jPkF9mgA__ 768w, __VITE_ASSET__U2YZxvNlcnuoWcGKwa9Wsw__ 1200w";